export default function filter() {

  $('#downloads .form__select').change(function () {
    location.href = $(this).val();
    //$('#downloads input[name="search"]').val('');
    //faqquestions();
  });
  
}